// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import Box from 'sail/Box';
import {Text} from 'sail/Text';
import {CardGroupQuickLinks} from './CardGroupQuickLinks';
import './CardGroup.scss';

const CardGroupFooterLink = ({label, href}) => {
  const external = href.match(/^\w+:\/\//);
  return (
    <Box padding={{top: 16}}>
      <Text align="right">
        <ButtonLink
          size="large"
          display="inline-flex"
          className="no-api-tag"
          label={label}
          href={href}
          target={external ? '_blank' : undefined}
          icon={external ? 'external' : 'arrowRight'}
          iconPosition="right"
        />
      </Text>
    </Box>
  );
};

type CardGroupProps = {|
  children: React.Node,
  title: string,
  footerLink?: {|label: string, href: string|},
  quickLinks?: Array<{|label: string, href: string|}>,
  removePadding?: boolean,
|};

export const CardGroup = ({
  children,
  title,
  footerLink,
  quickLinks,
  removePadding,
}: CardGroupProps) => {
  return (
    <Box
      className="CardGroup"
      margin={{top: title ? 48 : 0}}
      style={{
        // Bottom padding is added to balance the sections without footer links
        paddingBottom: !footerLink && !removePadding ? 40 : undefined,
      }}
    >
      <Text size={20} weight="bold" color="dark">
        {title}
      </Text>
      {quickLinks ? <CardGroupQuickLinks links={quickLinks} /> : null}
      <Box className="CardGroup-cards">{children}</Box>
      {footerLink && <CardGroupFooterLink {...footerLink} />}
    </Box>
  );
};
